import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';

import find from 'lodash/find';

import { observer } from 'mobx-react-lite';
import ObservableAutoSizer from '@vromo/ui/components/ObservableAutoSizer';

const hours = [
    '12am',
    '1am',
    '2am',
    '3am',
    '4am',
    '5am',
    '6am',
    '7am',
    '8am',
    '9am',
    '10am',
    '11am',
    '12pm',
    '1pm',
    '2pm',
    '3pm',
    '4pm',
    '5pm',
    '6pm',
    '7pm',
    '8pm',
    '9pm',
    '10pm',
    '11pm'
];

interface Props {
    jobsByHourCompleted: {
        key: string;
        value: number;
    }[];
}
export default observer<Props>(function HourlyBarChart({ jobsByHourCompleted }) {
    const formatHourLabel = (label: string) => {
        return `${label} - ${hours[(hours.indexOf(label) + 1) % hours.length]}`;
    };

    const data = hours.map((h) => {
        const result = { name: h, value: 0 };

        const jobsCompleted = find(jobsByHourCompleted, (j) => j.key == h);

        result.value = jobsCompleted ? jobsCompleted.value : 0;

        return result;
    });

    return (
        <ObservableAutoSizer customChildren={({ width }: { width: number }) => (
            <BarChart
                width={width}
                height={220}
                data={data}
                margin={{
                    top: 5,
                    right: 30,
                    left: 0,
                    bottom: 5
                }}>
                <CartesianGrid strokeDasharray="3 5" />
                <XAxis dataKey="name" minTickGap={20} />
                <YAxis allowDecimals={false} />
                <Tooltip
                    labelFormatter={(label) => formatHourLabel(label)}
                    formatter={(value: number) => [value, 'Jobs Completed']}
                />
                <Bar dataKey="value" fill="#59CD90" />
            </BarChart>
        )} />
    );
});
